import {
    monthsIndexes,
    getSelectedYearMonths
} from '../../../../Util/getMonthsByYear';
import { defaultColors } from '../../../contexts/ServicesChartsDataContext';
import { useServicesChartsDataContext } from '../../../hooks/useServicesChartsDataContext';

const useServicesPerMonthPerYearCompareChart = () => {
    const { chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const data = [
        'Total - Ano Atual',
        'Total - Ano Anterior'
    ].map((item) => {
        const data = months.map((month) => {
            const found = chartData.selectedYear.find(
                (counter) =>
                    counter.description === item &&
                    parseInt(counter.mes_competencia, 10) ===
                        monthsIndexes[month]
            );

            return found ? Number(found.services) : 0;
        });

        return {
            name: item,
            data,
            type: item === 'Total - Ano Atual' ? 'bar' : 'line'
        };
    });

    const chartConfig = {
        series: data,
        options: {
            chart: {
                type: 'line',
                height: 400,
                stacked: false,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    endingShape: 'rounded',
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => val.toLocaleString('pt-BR')
                }
            },
            stroke: {
                width: [4, 4]
            },
            xaxis: {
                categories: months
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val.toLocaleString('pt-BR')}`,
                style: {
                    colors: ['#333']
                },
                offsetX: 0,
                offsetY: -20,
                enabledOnSeries: [0]
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useServicesPerMonthPerYearCompareChart;
